import { useCallback, useContext, useState } from 'react';

import { File as UploadedFile } from '../../../graphql/generated/graphql';
import { CreateModificationRequestDeliverableError } from '../../../service/persistent/ModificationRequestWebApi';
import { context as DependencyContext } from '../../context/dependency';

const useCreateModificationRequestDeliverable = (targetModificationRequestId: string) => {
  const dependency = useContext(DependencyContext);
  const [creating, setCreating] = useState(0);
  const createDeliverable = useCallback(
    async (
      intent: string,
      file: UploadedFile,
      attachedThumbnail: UploadedFile | null,
      success: (param: string) => void,
    ) => {
      try {
        setCreating((creating) => ++creating);

        const attachedThumbnailId = attachedThumbnail ? attachedThumbnail.id : null;
        const deliverable = await dependency.modificationRequestWebApi.createModificationRequestDeliverable(
          targetModificationRequestId,
          file.id,
          attachedThumbnailId,
          intent,
        );
        dependency.messageDispatcher.notifyUnimportant('message.create_deliverable_succeeded');
        success(deliverable.id);
      } catch (err) {
        if (err instanceof CreateModificationRequestDeliverableError) {
          dependency.errorPresenter.showAsNonFatal(new Error('message.create_deliverable_failed'));
        } else {
          dependency.errorPresenter.showAsNonFatal(err);
        }
      } finally {
        setCreating((creating) => --creating);
      }
    },
    [dependency, targetModificationRequestId],
  );

  return { createDeliverable, creating: creating > 0 };
};

export default useCreateModificationRequestDeliverable;
